import { combineReducers } from 'redux';

import genericErrorReducer from 'modules/global/reducers/generic.error';
import genericLoadingReducer from 'modules/global/reducers/generic.loading';
import * as types from 'modules/statistics/actionTypes';

import data from './data';

export default combineReducers({
  data,
  apiError: genericErrorReducer(types.FETCH_AUDIT_IN_FILES_SUMMARY_REQUEST),
  isFetching: genericLoadingReducer(types.FETCH_AUDIT_IN_FILES_SUMMARY_REQUEST),
});
